const style = (theme) => {
  const output = {
    root: {
      display: 'flex',
      '& > *': {
        width: '50%',
      },
    },
    rootReverse: {
      '& $desc': {
        order: 999,
      },
    },
    pretitle: {
      fontSize: 10,
      textTransform: 'uppercase',
      marginBottom: 30,
      lineHeight: 1,
    },
    desc: {
      paddingTop: 6,
    },
    info: {
      width: '70%',
      '& h2': {
        fontSize: 16,
      },
    },
    title: {
      fontSize: 60,
      lineHeight: 1,
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {
    root: {
      flexDirection: 'column',
      '& > *': {
        width: '100%',
        '&:not(:last-child)': {
          marginBottom: 30,
        },
      },
    },
    desc: {
      paddingTop: 0,
    },
    info: {
      width: '100%',
    },
    rootReverse: {
      '& > *': {
        '&:not(:first-child)': {
          marginBottom: 30,
        },
        '&:not(:last-child)': {
          marginBottom: 0,
        },
      },
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    title: {
      fontSize: 35,
    },
  }

  return output
}
export default style
